import React from 'react';
import StudentDashboardLayout from '../../../layouts/gcstudent/studentdashboardLayout/StudentDashboardLayout';
import MyBookPage from '../../../subsreens/gcstudent/mybookpage/MyBookPage'; 

const MyBooks = () => {
    return(
        <StudentDashboardLayout>
            <MyBookPage></MyBookPage>
        </StudentDashboardLayout>
    )
}

export default MyBooks;